module.exports = __webpack_public_path__ + "static/img/ys-3.a9d0b39.webp";


//////////////////
// WEBPACK FOOTER
// ./static/images/ys-3.webp
// module id = tpKo
// module chunks = 11